module.exports = __webpack_public_path__ + "img/text-blocks.d1416131.svg";